<template>
  <pack-form
    :initPack="initPack"
    :successMsg="t('packCreated')"
    :submitAction="submit"
    enableClearForm
    clearFormOnSubmit
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PackForm from '@/views/inventory/packs/PackForm.vue'

import Pack from '@/models/inventory/Pack'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-pack',
  components: {
    PackForm
  },
  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          packCreated: 'Pack was created successfully'
        },
        ar: {
          packCreated: 'تم انشاء الرزمة بنجاح'
        }
      }
    })

    return { t }
  },
  data() {
    return {
      initPack: new Pack()
    }
  },

  methods: {
    async submit(pack: Pack) {
      try {
        await this.$http.post(Pack.ENDPOINT, pack)
        await this.$router.push(this.$Route.INVENTORY_PACKS)
      } catch (error) {
        return error
      }
    }
  }
})
</script>

<style></style>
